import { compact, map, values } from "lodash";
import { createEdge } from "./shared";
import { createMembersCollectionNode } from "./createMembersCollectionNode";

export const initializeMemberNodesAndEdges = ({ contextualData, state }) => {
  const allMembers = values(state.members);
  const expandedTeams = compact(
    map(state.expandedNodes, (nodeId) => state.teams[nodeId])
  );

  const nodes = [];
  const edges = [];

  // create collection nodes for each team, even if they will be empty
  expandedTeams.forEach((team) => {
    // get members for this team
    const members = allMembers.filter((member) =>
      member.memberOf.find((mo) => mo.id === team.id)
    );

    // create collection node
    const collection = createMembersCollectionNode({
      group: team,
      contextualData,
      state,
      members,
    });
    nodes.push(collection);

    // add edge to parent
    edges.push(createEdge(team.id, collection.id));

    // HELP-10157: Hide fully loaded empty member collection nodes
    if (
      collection.data.itemsCount >= collection.data.itemsMax &&
      collection.data.items.length === 0
    ) {
      collection.data.hidden = true;
    }
  });

  return {
    nodes,
    edges,
  };
};
